import { render, staticRenderFns } from "./market-order-detail.vue?vue&type=template&id=5da2ec9d&scoped=true&"
import script from "./market-order-detail.vue?vue&type=script&lang=js&"
export * from "./market-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./market-order-detail.vue?vue&type=style&index=0&id=5da2ec9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da2ec9d",
  null
  
)

export default component.exports